export const tooOld = value =>
  value && value > 65 ? 'You might be too old for this' : undefined



// WEBPACK FOOTER //
// ./src/components/demo/fieldLevelValidation/warnDesc.js